module.exports = __webpack_public_path__ + "media/images/redesign-images/ma/profile-images/lexi-johnson-fb4fe5d357c161926cab8dd032e7a7c9.jpg";